import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ChangepasswordService } from 'src/app/_services/admin/changepassword.service';
import { CategoryService } from '../../../../_services/admin/category.service';
import { isNullOrUndefined } from 'util';
import { MatSnackBar } from '@angular/material';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-productcatedit',
  templateUrl: './productcatedit.component.html',
  styleUrls: ['./productcatedit.component.scss']
})
export class ProductcateditComponent implements OnInit {

  categoryList: any[] = [];
  EditProductCategoryForm: FormGroup;
  isEditProductCategoryFormSubmitted = false;
  parentCategorySelected: string = '0';

  constructor(private formBuilder: FormBuilder,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private myTitle: Title,
    private snackBar: MatSnackBar,
    private router: Router) {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.EditProductCategoryForm = this.formBuilder.group({
          id: new FormControl(params['id'], Validators.required),
          catename: new FormControl('', Validators.required),
          ddlProductCategory: new FormControl('', Validators.required),
        });
        this.getProductData(params['id']);
        this.EditProductCategoryForm.controls['id'].setValue(params['id']);
      }
    });
  }

  ngOnInit() {
    this.myTitle.setTitle('Edit Product Category details | ' + environment.commonTitle);
    this.getCategory();
  }

  getCategory() {
    this.categoryService.getAllCategories().subscribe((result) => {
      if (result.data) {
        this.categoryList = result.data;
      }
    });
  }

  getProductData(id: number) {
    this.categoryService.getAllCategoriesbyid(id).subscribe((data) => {
      if (data.data) {
        const resdata = data.data;
        this.EditProductCategoryForm.controls['catename'].setValue(resdata.categoryName);
        this.EditProductCategoryForm.controls['ddlProductCategory'].setValue(resdata.parentCategoryID);
      }
    });
  }

  updateproduct() {
    if (this.EditProductCategoryForm.valid) {
      const objdata = {
        Id: this.EditProductCategoryForm.value.id,
        CategoryName: this.EditProductCategoryForm.value.catename,
        ParentCategoryID: this.EditProductCategoryForm.value.ddlProductCategory,
      };
      this.categoryService.updateproductcate(objdata).subscribe(result => {
        if (result.data) {
          this.openSnackBar('Product updated succcessfully.', 'Success.');
        }
      }, error => {
        this.openSnackBar(error, 'Failed to update Product.');
      });
    }
  }

  reditectCategoryList() {
    this.router.navigate(['/secure/home/product/category']);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

}





